import type { RunCodeChangesResolvedValue } from "../types";
import styles from "./styles.module.css";
import RunCodeChangesStringValue from "./StringValue";

const VALUE_CLASS: Record<RunCodeChangesResolvedValue["type"], string> = {
  string: styles.string,
  number: styles.number,
  boolean: styles.boolean,
};

type RunCodeChangesValueProps = {
  resolved: RunCodeChangesResolvedValue | undefined;
  knownAfterApply?: boolean;
};

const RunCodeChangesValue = ({ resolved, knownAfterApply }: RunCodeChangesValueProps) => {
  if (knownAfterApply) {
    return <span className={styles.knownAfterApply}>(known after apply)</span>;
  }

  if (!resolved) {
    return <span className={styles.undefined}>undefined</span>;
  }

  if (resolved.type === "string") {
    return <RunCodeChangesStringValue value={String(resolved.value)} />;
  }

  return <span className={VALUE_CLASS[resolved.type]}>{String(resolved.value)}</span>;
};

export default RunCodeChangesValue;
